import type { DeliveryEstimate } from '../api/addresses'

interface DeliveryCheckoutState {
  hasDeliveryLocation: boolean
  deliveryEstimate: DeliveryEstimate | undefined
  isDeliveryEstimatePending: boolean
  isDeliveryEstimateError: boolean
}

const SELECT_LOCATION_ERROR = 'Select a delivery location before placing the order.'
const CHECKING_COVERAGE_ERROR = 'Checking delivery coverage for this address. Try again in a moment.'
const COVERAGE_UNVERIFIED_ERROR =
  'We could not verify delivery coverage for this address. Try again before placing the order.'
const OUTSIDE_ZONE_ERROR = 'This delivery address is outside the current delivery zones.'

export function getDeliveryCheckoutError({
  hasDeliveryLocation,
  deliveryEstimate,
  isDeliveryEstimatePending,
  isDeliveryEstimateError,
}: DeliveryCheckoutState): string | null {
  if (!hasDeliveryLocation) {
    return SELECT_LOCATION_ERROR
  }

  if (deliveryEstimate) {
    return deliveryEstimate.isDeliverable ? null : OUTSIDE_ZONE_ERROR
  }

  if (isDeliveryEstimatePending) {
    return CHECKING_COVERAGE_ERROR
  }

  if (isDeliveryEstimateError) {
    return COVERAGE_UNVERIFIED_ERROR
  }

  return COVERAGE_UNVERIFIED_ERROR
}
